<tyt-full-layout>
  <header>

  </header>
  <app-spinner *ngIf="!ready"></app-spinner>
  <ng-container *ngIf="ready">
    <div class="row" id="feed">
      <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">

        <ng-container *ngIf="hasLiveItems">
          <tyt-feed-tag>Now</tyt-feed-tag>
          <div class="schedule-block now">
            <ng-container *ngFor="let item of activeLiveEvents">
              <div class="schedule-item" [class.live]="getEventStream(item)" [class.ended]="isEnded(item)">
                <div class="avatar" [responsiveBackgroundImage]="item.show.logo_square"></div>
                <div class="spacer">
                  <h1>
                    <ng-container *ngIf="item.use_title">
                      {{item.title}}
                    </ng-container>
                    <ng-container *ngIf="!item.use_title">
                      {{item.show.name}}
                    </ng-container>
                  </h1>
                  <tyt-plus-tag *ngIf="item.is_premium" [state]="item.unlock_premium ? 'unlocked' : 'locked'"></tyt-plus-tag>
                </div>
                <div class="watch" *ngIf="getEventStream(item)">
                  <a routerLink="/live/streams/{{getEventStream(item).id}}" class="live-button">
                    <tyt-live-tag></tyt-live-tag>
                  </a>
                </div>
                <div class="time" *ngIf="!getEventStream(item)">
                  {{item.air_time_unix * 1000 | date : 'h:mm a' : timezone}} {{generalTimeZoneString}}
                </div>
              </div>
            </ng-container>

            <ng-container *ngFor="let stream of adhocStreams">
              <div class="schedule-item live">
                <div class="avatar" style="background-color: black;">
                  <mat-icon>cell_tower</mat-icon>
                </div>
                <div class="spacer">
                  <h1>{{stream.original_title || stream.title || 'Watch Live'}}</h1>
                  <ng-container *ngIf="stream.premium">
                    <tyt-plus-tag></tyt-plus-tag>
                  </ng-container>
                </div>
                <a routerLink="/live/streams/{{stream.id}}" class="live-button">
                  <tyt-live-tag></tyt-live-tag>
                </a>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <hr *ngIf="hasLiveItems" />

        <div style="position: relative;">
          <div class="tz-selector">
            <a [class.active]="useTimezone == 'local'" href="javascript:;" (click)="switchTimezone('local')">Local</a>
            <a [class.active]="useTimezone == 'est'" href="javascript:;" (click)="switchTimezone('est')">ET</a>
            <a [class.active]="useTimezone == 'pst'" href="javascript:;" (click)="switchTimezone('pst')">PT</a>
          </div>
          <ng-container *ngIf="!liveSchedules">
            <app-spinner></app-spinner>
          </ng-container>
          <ng-container *ngIf="liveSchedules">
            <ng-container *ngFor="let day of liveSchedules">
              <ng-container *ngIf="day.live_schedules.length > 0">
                <tyt-feed-tag [attr.data-day-anchor]="day.day">{{getDayDisplay(day.day)}}</tyt-feed-tag>

                <div class="schedule-block">
                  <div class="schedule-item" [class.live]="getEventStream(item)" [class.ended]="isEnded(item)"
                    *ngFor="let item of day.live_schedules">
                    <div class="avatar" [responsiveBackgroundImage]="item.show.logo_square"></div>
                    <div class="spacer">
                      <h1>
                        <ng-container *ngIf="item.use_title">
                          {{item.title}}
                        </ng-container>
                        <ng-container *ngIf="!item.use_title">
                          {{item.show.name}}
                        </ng-container>
                      </h1>
                      <ng-container *ngIf="item.is_premium">
                        <tyt-plus-tag></tyt-plus-tag>
                      </ng-container>
                    </div>
                    <div class="watch" *ngIf="getEventStream(item)">
                      <a routerLink="/live/streams/{{getEventStream(item).id}}" class="live-button">
                        <tyt-live-tag></tyt-live-tag>
                      </a>
                    </div>
                    <div class="time" *ngIf="!getEventStream(item)">
                      {{item.air_time_unix * 1000 | date : 'h:mm a' : timezone}} {{generalTimeZoneString}}
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div id="sidebar" class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
        <tyt-plus-ad-block></tyt-plus-ad-block>
        <!-- <tyt-announcements-block></tyt-announcements-block> -->
        <tyt-feed-tag>Recent Videos</tyt-feed-tag>

        <tyt-production-view class="mini" *ngIf="recentEpisodes && recentEpisodes[0]" [production]="recentEpisodes[0]"
          [showFeedTag]="false" mode="episodes" limit="2">
        </tyt-production-view>
        <tyt-feed-tag>Recent Articles</tyt-feed-tag>
        <tyt-article-list-item class="mini" *ngIf="recentArticles && recentArticles[0]" [article]="recentArticles[0]"
          limit=4>
        </tyt-article-list-item>
      </div>
    </div>

  </ng-container>
</tyt-full-layout>